/* eslint-disable jsx-a11y/no-onchange */
import React from 'react';
import { Button, Col, Row, RowProps } from 'react-bootstrap';

import cx from 'classnames';

import { IDonationOption } from 'models/donationOption';
import { DonationOptionValues } from 'models/donationOptionValues';

interface IProps extends RowProps, DonationOptionValues {
  onChange?: (value: any) => any;
  value?: any;
  isGift: boolean;
}

const DonationOptionGridFilter: React.FC<IProps> = ({
  onChange = () => {},
  value,
  isGift = false,
  underValues = [5, 10, 30, 100],
  overValues = [100],
  className,
  ...props
}) => {
  const UNDER_VALUES_FILTERS = underValues.map(underValue => ({
    label: `${isGift ? 'Gifts ' : ''}under $${underValue}`,
    value: (donationOption: IDonationOption) =>
      donationOption.amount <= underValue,
  }));

  const OVER_VALUES_FILTERS = overValues.map(overValue => ({
    label: `${isGift ? 'Gifts ' : ''}over $${overValue}`,
    value: (donationOption: IDonationOption) =>
      donationOption.amount >= overValue,
  }));

  const FILTER_VALUES = [...UNDER_VALUES_FILTERS, ...OVER_VALUES_FILTERS];

  return (
    <>
      <select
        {...props}
        onChange={({ target: { value: valueLabel } }) => {
          onChange(FILTER_VALUES.find(({ label }) => label === valueLabel));
        }}
        className={cx(
          'd-block d-md-none form-control form-control-bordered bg-white',
          className,
        )}
      >
        <option value="">All</option>
        {FILTER_VALUES.map(filterValue => (
          <option key={filterValue.label} value={filterValue.label}>
            {filterValue.label}
          </option>
        ))}
      </select>
      <Row
        {...props}
        className={cx('justify-content-center d-none d-md-flex', className)}
      >
        <Col className="px-2 mb-2" xs="auto">
          <Button
            className="px-3"
            variant={value === undefined ? 'primary' : 'outline-primary'}
            onClick={() => onChange(undefined)}
          >
            All
          </Button>
        </Col>
        {FILTER_VALUES.map(filterValue => (
          <Col className="px-2 mb-2" key={filterValue.label} xs="auto">
            <Button
              className="px-3"
              variant={filterValue === value ? 'primary' : 'outline-primary'}
              onClick={() => onChange(filterValue)}
            >
              {filterValue.label}
            </Button>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default DonationOptionGridFilter;
